var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"quotes-container"},[_c('img',{staticClass:"quote-image",attrs:{"src":_vm.tool.imgURL,"alt":"image"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }